import { render, staticRenderFns } from "./PasswordResetMailSentSection.vue?vue&type=template&id=5c530c2e&scoped=true"
import script from "./PasswordResetMailSentSection.vue?vue&type=script&lang=ts"
export * from "./PasswordResetMailSentSection.vue?vue&type=script&lang=ts"
import style0 from "./PasswordResetMailSentSection.vue?vue&type=style&index=0&id=5c530c2e&prod&lang=scss&scoped=true"
import style1 from "./PasswordResetMailSentSection.vue?vue&type=style&index=1&id=5c530c2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c530c2e",
  null
  
)

export default component.exports